import React from 'react';
import { connect } from 'react-redux';

import ContentFeedList from '../../ContentFeedList/index.jsx';
import PagedData from '../../PagedData/index.jsx';
import Spinner from '../../Spinner/index.jsx';

import ContentFeedAPI from '../../../Services/ContentFeed/index.jsx';

import { fetch as fetchAssets, getAssetById, isAssetsLoading } from '../../../Store/assets.js';


class ContentFeed extends React.Component {
  constructor(props) {
    super(props);

    this.contentFeedAPI = new ContentFeedAPI();
    this.WrappedContentFeed = PagedData(ContentFeedList, this.contentFeedAPI);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.fetch();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.terms !== prevProps.terms && this._isMounted) {
      this.contentFeedAPI.setTerms(this.props.terms);
    }
  }

  render() {
    var content;

    if (this.props.loading || !this._isMounted) {
      content = (
        <div className="my-3">
          <Spinner />
        </div>
      );
    } else {
      content = (
        <this.WrappedContentFeed />
      );
    }


    return content;
  }
}


var mapStateToProps = function(state, ownProps) {
  var terms = [];

  if (ownProps.blockchains) {
    terms = terms.concat(ownProps.blockchains);
  }
  if (ownProps.categories) {
    terms = terms.concat(ownProps.categories);
  }

  // only include the assets we care about if they've been provided 
  if (ownProps.assets) {
    for (var i = 0; i < ownProps.assets.length; i++) {
      var asset = getAssetById(state, ownProps.assets[i]);

      if (asset) {
        terms.push(asset.term);
      }
    }
  }

  return {
    terms: terms,
    loading: isAssetsLoading(state)
  };
};

var mapDispatchToProps = function(dispatch) {
  return {
    fetch: function() {
      dispatch(fetchAssets());
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(ContentFeed);

